import { GooglePayButtonParams } from "@payair/google-pay-sdk/models/GooglePayButtonParams"
import { GooglePayInitParams } from "@payair/google-pay-sdk/models/GooglePayInitParams"
import { GooglePayButtonColorEnumsObj } from "@payair/google-pay-sdk/enums/GooglePayButtonColorEnum"
import { GooglePayButtonTypeEnumsObj } from "@payair/google-pay-sdk/enums/GooglePayButtonTypeEnum"
import { createSlice } from "@reduxjs/toolkit"
import set from "lodash/set"
import { GooglePayShippingOptionParameters } from "../../models/GooglePayInputData"

const googlePayShippingOptionParameters: GooglePayShippingOptionParameters = {
  defaultSelectedOptionId: "shippingOptionOneId",
  shippingOptions: [
    {
      id: "shippingOptionOneId",
      label: "shippingOptionOneLabel",
      description: "shippingOptionOneDescription",
    },
    {
      id: "shippingOptionTwoId",
      label: "shippingOptionTwoLabel",
      description: "shippingOptionTwoDescription",
    },
  ],
}

const googlePayInitParams: GooglePayInitParams = {
  currencyCode: "SEK",
  totalAmount: "1.00",
  totalAmountLabel: "Total",
  merchantName: "Payair test merchant",
  merchantId: "test.merchant.ape",
  pspName: "dev",
  transactionId: "Test tool" + Date.now(),
  environment: "QA",

  //Google Pay specific fields
  totalPriceStatus: "FINAL",
  paymentMethodType: "CARD",
  allowedCardNetworks: ["AMEX", "DISCOVER", "INTERAC", "JCB", "MASTERCARD", "VISA"],
  allowedCardAuthMethods: ["PAN_ONLY", "CRYPTOGRAM_3DS"],
  gateway: "payair",
  gatewayMerchantId: "exampleGatewayMerchantId",
  billingAddressRequired: true,

  //Dynamic price update
  shippingOptionRequired: true,
  shippingOptionParameters: googlePayShippingOptionParameters,
  shippingAddressRequired: true,
  shippingAddressParameters: { allowedCountryCodes: ["PL", "SE", "GB"] },
  locale: "",

  enablePromoCodes: true,
  emailRequired: true,
}

const googlePayButtonParams: GooglePayButtonParams = {
  buttonColor: GooglePayButtonColorEnumsObj.BLACK,
  buttonType: GooglePayButtonTypeEnumsObj.BUY,
}

const googlepayInputData = {
  googlePayInitParams: googlePayInitParams,
  googlePayButtonParams: googlePayButtonParams,
}

export const saveToStorage = (state: any, action: any) => {
  const payload = action.payload
  const name = payload.name
  const value = payload.value

  return set(state, name, value)
}

export const googlepayInputDataReducer = createSlice({
  name: "googlepayInputData",
  initialState: googlepayInputData,
  reducers: {
    save: (state, action) => {
      saveToStorage(state, action)
    },
  },
})

const { actions, reducer } = googlepayInputDataReducer
export const { save } = actions
export default reducer
